/**
 * Sizing utility styles with Bootstrap inspired naming.
 *
 * https://getbootstrap.com/docs/5.0/utilities/sizing/
 */
export default {
    h100: {
        height: '100%',
    },

    w20: {
        width: '20%',
    },

    w25: {
        width: '25%',
    },

    mnh100: {
        minHeight: '100%',
    },

    mnw2: {
        minWidth: 8,
    },

    mnw25: {
        minWidth: '25%',
    },

    w50: {
        width: '50%',
    },

    w70: {
        width: '70%',
    },

    w100: {
        width: '100%',
    },

    mwn: {
        maxWidth: 'auto',
    },

    mw100: {
        maxWidth: '100%',
    },

    w1: {
        width: 4,
    },

    wAuto: {
        width: 'auto',
    },
};
